<template>
	<div class="max-w-7xl mx-auto py-6">
		<Card v-if="deviceForm">
			<template #title>{{ $t('pages.devices.device.properties.edit_device') }}</template>
			<template #content>
				<DevicePropertiesForm
						:form="deviceForm"
						:disabled="!$auth.hasPermission('update:devices')"
						@on-save="saveDevice"
						@on-reset="deviceForm.reset()"
				/>
			</template>
		</Card>
	</div>
</template>

<script>
import DevicePropertiesForm from "@/Forms/Device/DevicePropertiesForm.vue";
import { mapStores } from "pinia";
import { useDevicesStore } from "@/stores/devices.js";

export default {
	name: "DevicePropertiesView",
	components: {DevicePropertiesForm},
	data() {
		return {
			deviceForm: undefined,
		}
	},
	computed: {
		...mapStores(useDevicesStore),
	},
	methods: {
		async saveDevice() {
			try {
				await this.deviceForm.submit();
        this.$toast.add({ severity: 'success', summary: 'Complete', detail: 'Device saved', life: 3000 });
        this.$emit('on-save');
			} catch (error) {
				//
			}
		},
	},
	watch: {
		'$route.params.device': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.device === 'NEW') {
						this.deviceForm = await this.devicesStore.createDevice();
					} else {
						this.deviceForm = await this.devicesStore.editDevice(this.$route.params.device);
					}
				} else {
					this.deviceForm = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>

<style scoped>

</style>